export const CLIENT_ID = 'I1XSZE5BEBHRTHYF1XHIQAC0SOVDUEF11LW2SHBLQHF4PDHQ';
export const CLIENT_SECRET = 'CNLWBTQ1KX4UQE2QCXVK14E1XNKGEYBIYIH2QC4YQWNMTO3X';

export const PARAMS = {
  client_id: CLIENT_ID,
  client_secret: CLIENT_SECRET,
  v: '20181112',
}